import { RenderActDocumentCell, RenderActDocumentContractors, RenderViolationsCell } from "../../components/ActTable/ActTable";

export const contractorActColumns = [
  { field: "sequenceNumber", headerName: "_", width: 50 },
  {
    field: "violation_id",
    headerName: "ID",
    width: 70,
    sortable: false,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "id",
    headerName: "№",
    width: 70,
    sortable: false,
    align: "center",
    headerAlign: "center",
    description: "Номер акта",
  },
  {
    field: "act_date",
    headerName: "Дата",
    type: "dateTime",
    width: 100,
    sortable: false,
    align: "center",
    headerAlign: "center",
    description: "Дата заполнения",
  },
  {
    field: "crew_number",
    headerName: "Бригада",
    type: "number",
    width: 120,
    align: "center",
    headerAlign: "center",
    description: "Номер бригады",
  },
  {
    field: "field",
    headerName: "Месторождение/куст/скв.",
    type: "string",
    width: 220,
    sortable: false,
    align: "center",
    headerAlign: "center",
    description: "Месторождение/куст/скважина",
  },
  {
    field: "podrFIO",
    headerName: "ФИО представителя",
    type: "string",
    width: 140,
    sortable: false,
    align: "center",
    headerAlign: "center",
    description: "ФИО представителя",
  },
  {
    field: "violation_name",
    headerName: "Нарушения",
    headerAlign: "center",
    width: 280,
    sortable: false,
    align: "center",
    description: "Нарушения",
    renderCell: RenderViolationsCell
  },
  {
    field: "status",
    headerName: "Статус",
    headerAlign: "center",
    type: 'boolean',
    width: 90,
    sortable: false,
    align: "center",
    description: "Статус",
  },
  {
    field: 'actFile',
    headerName: 'Акт',
    width: 70,
    filterable: false,
    sortable: false,
    renderCell: RenderActDocumentContractors
},
];
